import { writable, Writable } from "svelte/store";
import type { Errors } from "@shared/types/Errors";

class PageErrorStore {
  constructor(public errors: Writable<Errors> = writable({ messages: [], title: "" })) {}
}

// Export a singleton
export const pageErrorStore = new PageErrorStore();
